import { Store } from "@ngxs/store";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PlanningPortalGlobalState,
} from "../../../state/planning-portal-global-state/planning-portal-global.state";


@Injectable()
export class HttpClientIdInterceptor implements HttpInterceptor {
    
  constructor(private store: Store) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const clientId = this.store.selectSnapshot(PlanningPortalGlobalState.SelectedDistributionLane);
    
    const request = req.clone({
      setHeaders: {
        "clientId": clientId ?? ""
      },
    });

    return next.handle(request);
  }
}
